import { render, staticRenderFns } from "./uploadRecordDetail.vue?vue&type=template&id=271f2424&scoped=true&"
import script from "./uploadRecordDetail.vue?vue&type=script&lang=js&"
export * from "./uploadRecordDetail.vue?vue&type=script&lang=js&"
import style0 from "./uploadRecordDetail.vue?vue&type=style&index=0&id=271f2424&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "271f2424",
  null
  
)

export default component.exports